import React from 'react';
import { string, shape } from 'prop-types';
import Link from 'gatsby-link';
import Trunk8 from 'react-trunk8';
import cx from 'classnames';

import { Bar, BarItem } from '../';

const CLASS_ROOT = 'card__description';

const propTypes = {
  content: shape({
    content: string,
    date: string,
    time: string,
  }),
  href: string,
  tempHref: string,
  externalHref: string,
};

const CardDescription = ({
  className,
  children,
  style,
  content,
  href,
  tempHref,
  externalHref,
  ...other
}) => {
  const classes = cx(
    CLASS_ROOT,
    'd-flex-column',
    'align-items-justify',
    className,
  );

  const renderTimeDate = content.date &&
    content.time && (
      <Bar className="no-mrg" willWrap>
        <BarItem>
          <span className="text-small card__description-tag">
            {content.date}
          </span>
        </BarItem>
        <BarItem className="align-self-right">
          <span className="text-small card__description-tag">
            {content.time}
          </span>
        </BarItem>
      </Bar>
    );

  /* eslint-disable */
  return (
    <div className={classes} {...other} style={style}>
      {tempHref && <a href={tempHref} className="card__link" />}
      {href && <Link to={href} className="card__link" />}
      {externalHref && (
        <a
          href={externalHref}
          className="card__link"
          target="_blank"
          rel="noopener noreferrer"
        />
      )}
      <div
        className="text-small d-flex-column align-items-justify"
        style={{ height: '100%' }}
      >
        <Trunk8 lines={8}>{content.content}</Trunk8>
        {children}
      </div>
      {renderTimeDate}
    </div>
  );
  /* eslint-enable */
};

CardDescription.propTypes = propTypes;

export default CardDescription;
